import { Button } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { ampli } from 'lib-shared-tracking';
import { Component, ReactElement, ReactNode } from 'react';

import { buttonize } from '../../../../utils/a11y';

import styles from './dropdownTeam.module.scss';

type TimeoutID = undefined | NodeJS.Timeout;

type PropsT = {
  children?: ReactElement | (() => ReactNode);
  className?: string;
};

type StateT = {
  dropdownOpen: boolean;
};

export class Dropdown extends Component<PropsT, StateT> {
  dropdownWrap: HTMLElement | null;

  timeout: null | TimeoutID;

  constructor(props: PropsT) {
    super(props);

    this.state = {
      dropdownOpen: false,
    };

    this.dropdownWrap = null;
    this.timeout = null;

    this.setDropdownWrap = this.setDropdownWrap.bind(this);
    this.handleClickOutsideDropdown =
      this.handleClickOutsideDropdown.bind(this);
    this.handleDropdownClick = this.handleDropdownClick.bind(this);
    this.handleDropdownToggle = this.handleDropdownToggle.bind(this);
  }

  shouldComponentUpdate(nextProps: PropsT, nextState: StateT) {
    const { children } = this.props;
    const { dropdownOpen } = this.state;
    return (
      nextProps.children !== children || nextState.dropdownOpen !== dropdownOpen
    );
  }

  componentDidUpdate(prevProps: PropsT, prevState: StateT) {
    const { dropdownOpen } = this.state;

    if (dropdownOpen !== prevState.dropdownOpen) {
      this.timeout = setTimeout(() => {
        window[dropdownOpen ? 'addEventListener' : 'removeEventListener'](
          'click',
          this.handleClickOutsideDropdown,
        );
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.handleClickOutsideDropdown);
    if (this.timeout) {
      window.clearInterval(this.timeout);
    }
  }

  setDropdownWrap(element) {
    this.dropdownWrap = element;
  }

  handleClickOutsideDropdown(event: Event) {
    if (!this.dropdownWrap || !(event.target instanceof Node)) {
      return;
    }
    if (
      this.dropdownWrap &&
      event.target !== this.dropdownWrap &&
      !this.dropdownWrap.contains(event.target)
    ) {
      this.close();
    }
  }

  handleDropdownToggle() {
    const { dropdownOpen } = this.state;
    this.setState({
      dropdownOpen: !dropdownOpen,
    });
    if (!dropdownOpen) {
      ampli.teamConversationActionsMenuOpened();
    }
  }

  handleDropdownClick(event: Event) {
    event.stopPropagation();
    this.close();
  }

  close() {
    window.removeEventListener('click', this.handleClickOutsideDropdown);
    this.setState({
      dropdownOpen: false,
    });
  }

  render() {
    const { children, className, ...otherProps } = this.props;

    const { dropdownOpen } = this.state;

    const rootClass = classnames(
      {
        [styles.dropdownTeam]: true,
      },
      className,
    );
    return (
      <div
        {...otherProps}
        className={rootClass}
        role="menu"
        aria-expanded={dropdownOpen}
      >
        <div
          className={styles.dropdownToggleTeam}
          {...buttonize(this.handleDropdownToggle)}
        >
          <Button variant="secondary">Actions</Button>
        </div>
        {dropdownOpen && (
          <div
            ref={this.setDropdownWrap}
            className={styles.dropdownWrapTeam}
            {...buttonize(this.handleDropdownClick)}
          >
            {typeof children === 'function' ? children() : children}
          </div>
        )}
      </div>
    );
  }
}
